import React from 'react'
import { TextField } from '@mui/material'

const Buyer = ({ buyer, setBuyer }) => {
    return (
        <div>
            <TextField
                label="Buyer"
                size="small"
                fullWidth
                value={buyer}
                onChange={(event) => {
                    setBuyer(event.target.value);
                }}
            />
        </div>
    )
}

export default Buyer